import { storeToRefs } from 'pinia'
import {useMainStore, useSlidesStore} from "@/store";
import { copyText, readClipboard } from '@/utils/clipboard'
import { encrypt } from '@/utils/crypto'
import { message } from 'ant-design-vue'
import usePasteTextClipboardData from '@/hooks/usePasteTextClipboardData'
import useDeleteElement from './useDeleteElement'
import {nanoid} from "nanoid";

export default () => {
  const mainStore = useMainStore()
  const slidesStore = useSlidesStore()

  const { activeElementIdList, activeElementList } = storeToRefs(mainStore)

  const { pasteTextClipboardData } = usePasteTextClipboardData()
  const { deleteElement } = useDeleteElement()

  // Copy the encrypted data of the selected element to the clipboard
  const copyElement = () => {
    if (!activeElementIdList.value.length) return

    const addElements = []

    const dragDropElements = slidesStore.getElementsByType('dragdrop')
    const slideLayouts = slidesStore.getElementsByType('slidelayout')

    for (const element of activeElementList.value) {
      if (element.type === 'section') {
        const slideLayout =  slideLayouts.find(layout => layout.id === element.slideLayoutId)
        addElements.push(slideLayout)

        for (const section of slideLayout.layout.children) {
          for (const subsection of section.children) {
            const dragdrop = dragDropElements.find(dragDrop => dragDrop.id === subsection.id)
            addElements.push(dragdrop)
          }
        }
      }
    }

    activeElementList.value.push(...addElements)

    const text = encrypt(JSON.stringify({
      type: 'elements',
      data: activeElementList.value,
    }))

    copyText(text).then(() => {
      mainStore.setEditorareaFocus(true)
    })
  }

  // Copy the selected element and delete it (cut)
  const cutElement = () => {
    copyElement()
    deleteElement()
  }

  // Attempt to paste after decrypting clipboard element data
  const pasteElement = () => {
    readClipboard().then(text => {
      pasteTextClipboardData(text)
    }).catch(err => message.warning(err))
  }

  // Copy the selected element and paste it immediately
  const quickCopyElement = () => {
    copyElement()
    pasteElement()
  }

  return {
    copyElement,
    cutElement,
    pasteElement,
    quickCopyElement,
  }
}
